import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 12c1.667 0 3.083-.583 4.25-1.75C11.417 9.083 12 7.667 12 6c0-1.667-.583-3.083-1.75-4.25C9.083.583 7.667 0 6 0c-.903 0-1.74.188-2.51.563a6.348 6.348 0 0 0-1.99 1.5V.75a.728.728 0 0 0-.214-.534A.72.72 0 0 0 .754 0 .734.734 0 0 0 .22.216.72.72 0 0 0 0 .75v3.5c0 .213.072.39.216.534A.726.726 0 0 0 .75 5h3.5c.213 0 .39-.071.534-.214A.72.72 0 0 0 5 4.254a.734.734 0 0 0-.216-.535.72.72 0 0 0-.534-.219H2.27a4.439 4.439 0 0 1 1.584-1.458A4.36 4.36 0 0 1 6 1.5c1.25 0 2.313.438 3.188 1.313C10.062 3.687 10.5 4.75 10.5 6c0 1.25-.437 2.313-1.312 3.188C8.312 10.062 7.25 10.5 6 10.5c-1.042 0-1.958-.316-2.75-.948a4.407 4.407 0 0 1-1.562-2.385.785.785 0 0 0-.344-.459.79.79 0 0 0-.553-.125.733.733 0 0 0-.5.282c-.124.16-.166.336-.124.53a5.923 5.923 0 0 0 2.083 3.303C3.32 11.566 4.57 12 6 12"
    />
  </svg>
);
export default SvgRefresh;
